/* NUVA editorial — página de producto de los 5 kits (Fase 2): comportamiento.
   ----------------------------------------------------------------
   Los textos del nivel los rellenan los <script> en línea de
   sections/nve-producto-nivel.liquid (desde nuva-kit-config, antes de pintar).
   Aquí solo: miniaturas de la galería, estado "Agregando…" del botón de compra,
   barra de compra fija en móvil y ocultar los botones flotantes mientras el
   bloque principal está en pantalla (móvil). Nunca toca precios ni el carrito
   más allá del envío normal del formulario de Shopify. */
(function () {
  'use strict';

  var MQ_MOVIL = window.matchMedia('(max-width: 989px)');

  /* ---- Galería: las miniaturas cambian la foto principal (la misma foto de Shopify) ---- */
  function initGaleria(root) {
    var main = root.querySelector('.nve-pdp__img');
    var thumbs = root.querySelectorAll('[data-nve-pdp-thumb]');
    thumbs.forEach(function (b) {
      b.addEventListener('click', function () {
        if (!main) return;
        main.srcset = b.getAttribute('data-srcset') || '';
        main.src = b.getAttribute('data-src');
        main.alt = b.getAttribute('data-alt') || '';
        if (b.getAttribute('data-w')) { main.width = +b.getAttribute('data-w'); main.height = +b.getAttribute('data-h'); }
        thumbs.forEach(function (o) { o.setAttribute('aria-pressed', o === b ? 'true' : 'false'); });
      });
    });
  }

  /* ---- "Agregando…" y bloqueo de doble envío (Start/Growth) ---- */
  function initCompra(root) {
    var form = document.getElementById('nve-pdp-form');
    if (!form) return;
    var botones = root.querySelectorAll('[data-nve-pdp-add]');
    var enviando = false;
    form.addEventListener('submit', function (e) {
      if (enviando) { e.preventDefault(); return; }
      enviando = true;
      botones.forEach(function (b) {
        if (!b.hasAttribute('data-texto-original')) b.setAttribute('data-texto-original', b.textContent);
        b.textContent = b.getAttribute('data-texto-cargando') || 'Agregando…';
        b.setAttribute('aria-busy', 'true');
        b.classList.add('is-cargando');
      });
    });
    /* al volver con "atrás" (caché del navegador) el botón vuelve a su estado normal */
    window.addEventListener('pageshow', function () {
      enviando = false;
      botones.forEach(function (b) {
        if (b.hasAttribute('data-texto-original')) b.textContent = b.getAttribute('data-texto-original');
        b.removeAttribute('aria-busy');
        b.classList.remove('is-cargando');
      });
    });
    var sel = form.querySelector('select[name="id"]');
    if (sel) sel.addEventListener('change', function () {
      var op = sel.options[sel.selectedIndex];
      botones.forEach(function (b) { b.disabled = !!(op && op.disabled); });
    });
  }

  /* ---- Barra de compra fija (móvil): visible solo cuando no se ve ningún botón de compra ---- */
  function initBarra(root) {
    var barra = root.querySelector('[data-nve-pdp-barra]');
    if (!barra || !('IntersectionObserver' in window)) return;
    var html = document.documentElement;
    var vigilados = [].slice.call(root.querySelectorAll('[data-nve-pdp-compra], [data-nve-pdp-cta-final], #personaliza-tu-mezcla'));
    var pie = document.querySelector('.nve-footer') || document.querySelector('footer');
    if (pie) vigilados.push(pie);
    var compra = root.querySelector('[data-nve-pdp-compra]');
    var visibles = new Set();
    var compraPasada = false; /* la barra solo aparece después de pasar el botón principal (no tapa el precio al cargar) */
    var listo = false;

    /* barra de vista previa de Shopify (solo la ve quien administra la tienda): la barra sube sobre ella */
    function medir() {
      var pb = document.getElementById('preview-bar-iframe');
      var h = 0;
      if (pb && getComputedStyle(pb).display !== 'none') {
        var r = pb.getBoundingClientRect();
        if (r.height > 0 && r.top < window.innerHeight && r.bottom >= window.innerHeight - 2) h = Math.round(window.innerHeight - r.top);
      }
      html.style.setProperty('--nve-pdp-offset', h + 'px');
      html.style.setProperty('--nve-pdp-barra-h', barra.offsetHeight + 'px');
    }

    function actualizar() {
      if (!listo) return;
      /* se mide en cada llamada: un salto por ancla puede pasar el botón sin que el observador avise */
      compraPasada = compra ? compra.getBoundingClientRect().bottom < 72 : true;
      var activa = MQ_MOVIL.matches && compraPasada && visibles.size === 0;
      if (activa) medir();
      barra.classList.toggle('is-visible', activa);
      html.classList.toggle('nve-pdp-barra-activa', activa);
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) visibles.add(en.target); else visibles.delete(en.target); });
      listo = true;
      actualizar();
    }, { rootMargin: '-72px 0px -10% 0px' }); /* lo que queda bajo el encabezado fijo no cuenta como visible */
    vigilados.forEach(function (n) { io.observe(n); });
    var pendiente = false;
    window.addEventListener('scroll', function () {
      if (pendiente) return;
      pendiente = true;
      requestAnimationFrame(function () { pendiente = false; actualizar(); });
    }, { passive: true });
    if (MQ_MOVIL.addEventListener) MQ_MOVIL.addEventListener('change', actualizar);
    window.addEventListener('resize', function () { if (barra.classList.contains('is-visible')) medir(); });
    setTimeout(function () { if (barra.classList.contains('is-visible')) medir(); }, 1500);
  }

  /* ---- Móvil: mientras el bloque principal está en pantalla se ocultan los botones flotantes
     (WhatsApp y música) para que no tapen la foto ni los botones — misma regla CSS del Home ---- */
  function initHeroEnPantalla(root) {
    var hero = root.querySelector('.nve-pdp__hero');
    if (!hero || !('IntersectionObserver' in window)) return;
    /* margen superior = encabezado fijo: lo que queda debajo del encabezado ya no cuenta como "en pantalla" */
    new IntersectionObserver(function (entries) {
      document.documentElement.classList.toggle('nve-hero-en-pantalla', entries[0].isIntersecting);
    }, { rootMargin: '-72px 0px 0px 0px' }).observe(hero);
  }

  function initPdp(root) {
    if (root._nvePdp) return;
    root._nvePdp = true;
    initGaleria(root);
    initCompra(root);
    initBarra(root);
    initHeroEnPantalla(root);
  }

  function initAll() { document.querySelectorAll('[data-nve-pdp]').forEach(initPdp); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target.querySelector('[data-nve-pdp]');
    if (r) initPdp(r);
  });
})();
